import { useContext } from 'react';

import { MicroguideContext } from '../contexts/MicroguideContext.js';
import type { MicroguideContextType } from '../contexts/MicroguideContext.js';

/** @internal */
export const useMicroguideContext = (): MicroguideContextType =>
  useContext(MicroguideContext);
